<template>
  <el-dialog 
    :model-value="visible" 
    @close="$emit('close')"
    width="400px"
    :close-on-click-modal="false"
    append-to-body
    dialog-class="custom-dialog-radius">
  <div class="login-container">
    <!-- 标题 -->
    <div class="dialog-title">手机号登录</div>

    <!-- 表单 -->
    <el-form label-position="top" :model="form" ref="formRef">
      <!-- 手机号 -->
      <el-form-item >
        <div class="input-box phone-input">
          <span class="country-code">+86</span>
          <el-input v-model="form.phone" placeholder="请输入手机号码" maxlength="11" type="tel"></el-input>
        </div>
      </el-form-item>

      <!-- 验证码 -->
      <el-form-item >
        <div class="input-box code-input">
          <span class="code-label">验证码</span>
          <el-input v-model="form.code" placeholder="请输入" maxlength="6"></el-input>
          <el-button type="primary" class="get-code-btn" @click="handleGetVerificationCode" :disabled="countdown > 0">
            <span>{{ countdown > 0 ? `重新发送(${countdown}s)` : '获取验证码' }}</span>
          </el-button>
        </div>
      </el-form-item>

      <!-- 用户协议复选框 -->
      <div class="terms-checkbox">
        <el-checkbox v-model="agreeTerms">我已阅读并同意</el-checkbox>
        <a href="#" class="agreement-link" @click.prevent="goToUserAgreement">《用户协议》</a>
      </div>

      <!-- 登录按钮 -->
      <div class="button-container">
        <el-button
          type="primary"
          class="login-btn"
          @click="handleLogin"
        >
          <span>登录</span>
        </el-button>
      </div>
    </el-form>
  </div>
  </el-dialog>
</template>

<script>
import {login, code} from "../api/login/login";
export default {
  name: 'UserLogin',
  data() {
    return {
      form: {
        userId: 1, // 用户ID
        phone: '', // 手机号
        token: '', // 令牌
        type: '', // 用户令牌类型
        scene: 'login', // 场景，例如 'login'
        code: '', // 验证码
        password: '' // 密码
      },
      agreeTerms: false, // 是否同意用户协议
      countdown: 0, // 倒计时
    };
  },
  props: {
    visible: Boolean
  },
  methods: {
    goToUserAgreement() {
      window.open(this.$router.resolve({ name: 'home',
         query: { activeIndex: 2,showUserAgreement:true }}).href, '_blank');
    },
    goToContact(){
      const routeUrl = this.$router.resolve({
        name: 'home', // 假设 Homepage 的路由名称为 'Homepage'
        query: { activeIndex: 4 } // 通过 query 参数传递 activeIndex
      })
      window.open(routeUrl.href, '_blank')
    },
    // 处理重新发送验证码
    handleResendCode() {
      console.log('重新发送验证码...');
    },
    // 处理获取验证码
    async handleGetVerificationCode() {
      if (this.countdown > 0) return;
      // 准备登录信息
      const obj = Object.assign({}, this.form);
      obj.scene = 'login';
      code(obj).then(response => {
          if (response.code === 200) {
            this.$notify({ title: '成功', message: '验证码已发送', type: 'success', duration: 2000 });
            // 启动倒计时
            this.countdown = 60;
            const timer = setInterval(() => {
              if (this.countdown <= 0) {
                clearInterval(timer);
              } else {
                this.countdown--;
              }
            }, 1000);
          } else {
            this.$alert(response.message, '提示', { type: 'warning' });
          }
        }).catch(error => {
          console.error(error);
        });
    },
    // 处理登录
    async handleLogin() {
      if (!this.agreeTerms) {
        this.$message.error('请先同意用户协议');
        return;
      }
      console.log('登录提交:', this.form);
      const obj = Object.assign({}, this.form);
      login(obj).then(response => {
          console.log('登录成功:', response);
          if (response.code === 200) {
            this.$notify({
              title: '成功',
              message: '登录成功',
              type: 'success',
              duration: 2000
            })
            this.$emit('loginSuccess', response.data)
          } else {
            this.$alert(response.message, '提示', { type: 'warning' })
          }
        }).catch(error => {
          console.error(error)
        })
    },
  },
};
</script>
<style scoped>
.login-container {
  padding: 0px 8px 8px 8px;
}

.dialog-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 12px;
}

/* 统一输入容器：与 LoginPage 风格对齐 */
.input-box {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  height: 40px;
  width: 100%;
}
.input-box :deep(.el-input__wrapper) {
  box-shadow: none !important;
}
.input-box :deep(.el-input__inner) {
  height: 40px;
}
.input-box .el-input {
  flex: 1;
}

/* 左侧标签/区号，统一宽度，右侧竖边界对齐 */
.country-code,
.code-label {
  box-sizing: border-box;
  width: 76px;
  padding: 0 12px;
  border-right: 1px solid #ddd;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  white-space: nowrap;
}

/* 手机号输入：区号文本样式 */
.country-code {
  color: #333;
  font-size: 14px;
  background-color: #fff;
}

/* 验证码输入：左侧标签文本样式 */
.code-label {
  color: #666;
  font-size: 14px;
}

/* 验证码按钮固定宽度 */
.get-code-btn {
  min-width: 110px;
  padding: 0 12px;
  height: 100%;
  background-color: transparent;
  border: none;
  color: #409eff;
  font-size: 13px;
  cursor: pointer;
  border-left: 1px solid #ddd;
  white-space: nowrap;
}
.get-code-btn.is-disabled,
.get-code-btn:disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}
.get-code-btn:hover:not(.is-disabled) {
  background-color: #f8f9fa;
}

/* 用户协议复选框 */
.terms-checkbox {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 12px;
}

.agreement-link {
  color: #409eff;
  text-decoration: underline;
}

/* 按钮容器 */
.button-container {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin-top: 20px !important;
  position: relative !important;
}

/* 登录按钮 */
.login-btn {
  width: 120px;
  height: 40px;
  border-radius: 8px;
  background: #409eff;
  color: #fff;
  font-size: 16px;
  border: none;
}

/* 表单样式 */
:deep(.el-form-item__label) {
  font-weight: 600 !important;
  font-size: 14px !important;
  color: #1f2329 !important;
  display: block;
  margin-bottom: 8px;
}

:deep(.el-input__inner) {
  height: 40px;
  font-size: 14px;
}

:deep(.el-input__inner::placeholder) {
  font-size: 14px;
  color: #b8b2b2;
}

.el-form-item {
  margin-bottom: 12px;
}

/* 输入框提示文字 */
.input-tip {
  color: #999;
  font-size: 12px;
  margin-top: 2px;
}

/* 字数统计 */
.input-count {
  color: #bbb;
  font-size: 12px;
  text-align: right;
  margin-top: 2px;
}

/* 弹窗圆角 */
.custom-dialog-radius .el-dialog__body {
  border-radius: 10px;
}

/* 移动设备适配 */
@media (max-width: 768px) {
  .el-dialog {
    width: 95vw !important;
    max-width: 95vw !important;
    margin: 2.5vw auto !important;
  }
  .login-container {
    padding: 20px 16px;
  }
  .dialog-title {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }
  :deep(.el-form-item__label) {
    font-size: 13px !important;
    margin-bottom: 6px;
  }
  :deep(.el-input__inner) {
    height: 40px;
    font-size: 14px;
  }
  .input-tip,
  .input-count {
    font-size: 11px;
  }
  .button-container {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    margin-top: 20px !important;
    position: relative !important;
  }
  .login-btn {
    width: 100%;
    height: 44px;
    font-size: 16px;
    margin-top: 20px;
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .el-dialog {
    width: 80vw !important;
    max-width: 80vw !important;
  }
  .login-container {
    padding: 24px 20px;
  }
  .dialog-title {
    font-size: 1.6rem;
  }
  :deep(.el-input__inner) {
    height: 42px;
    font-size: 15px;
  }
  .button-container {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    margin-top: 20px !important;
    position: relative !important;
  }
  .login-btn {
    width: 140px;
    height: 42px;
    font-size: 15px;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .el-dialog {
    width: 98vw !important;
    max-width: 98vw !important;
    margin: 1vw auto !important;
  }
  .login-container {
    padding: 16px 12px;
  }
  .dialog-title {
    font-size: 1.3rem;
    margin-bottom: 16px;
  }
  :deep(.el-form-item__label) {
    font-size: 12px !important;
    margin-bottom: 4px;
  }
  :deep(.el-input__inner) {
    height: 38px;
    font-size: 13px;
  }
  .input-tip,
  .input-count {
    font-size: 10px;
  }
  .button-container {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    margin-top: 16px !important;
    position: relative !important;
  }
  .login-btn {
    height: 40px;
    font-size: 15px;
    margin-top: 16px;
  }
}

/* 横屏手机适配 */
@media (max-width: 900px) and (max-height: 600px) {
  .el-dialog {
    width: 90vw !important;
    max-width: 90vw !important;
    max-height: 90vh !important;
    overflow-y: auto;
  }
  .login-container {
    padding: 20px 16px;
  }
  .button-container {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    margin-top: 20px !important;
    position: relative !important;
  }
  .login-btn {
    width: 120px;
    height: 38px;
    font-size: 14px;
  }
}
</style>